import { z } from 'zod/v3';
import { createPaginationSchema } from '../../common/utils/schema';
import { zIsoDateTime } from '../../common/utils/schema/zIsoDateTime';
import { ChangedBySchema } from '../../user';

export const BusinessLogItemValue = z.object({
  value: z.string().nullable(),
  count: z.number().nullable(),
});

export const BusinessLogItemSchema = z.object({
  id: z.number(),
  key: z.string(),
  value: BusinessLogItemValue,
  groupNr: z.number().nullable(),
});

export const BusinessLogSchema = z.object({
  id: z.number(),
  createdAt: zIsoDateTime(),
  createdBy: ChangedBySchema.nullable(),
  action: z.string(),
  traceId: z.string().nullable(),
  logData: z.array(BusinessLogItemSchema),
  logData2: z.array(BusinessLogItemSchema),
});

export const BusinessLogPageSchema = createPaginationSchema(BusinessLogSchema);
